import useSWR from "swr";
import { InitialMapStateDto } from "../generated/models/initialMapStateDto";
import { getSettingsControllerGetInitialMapStateV0Url, settingsControllerGetInitialMapStateV0 } from "../generated/endpoints/settings/settings";
import { ApiResponse } from "@/types/apiResponse";
export const useInitialMapState = () => {
  return useSWR(getSettingsControllerGetInitialMapStateV0Url, settingsControllerGetInitialMapStateV0);
};